import React from 'react';
import Skeleton, { SkeletonProps } from '@mui/material/Skeleton';
import { useStacklineTheme } from '@stackline/ui';

/**
 * Wrapper around MUI skeleton that matches the mocks
 */
const SlSkeleton = (props: SkeletonProps) => {
  const theme = useStacklineTheme();

  return (
    <Skeleton
      {...props}
      sx={{
        ...(props?.sx ?? {}),
        backgroundColor: theme.colors.secondaryGhost
      }}
    />
  );
};

export default SlSkeleton;
